import { featureToggle } from "@faire/web/common/settings/declarations/featureToggle";

export const FE_HOMEPAGE_IMAGE_URLS_250623 = featureToggle({
  name: "FE_HOMEPAGE_IMAGE_URLS_250623",
  defaultValue: false,
  identifier: "RetailerToken",
  client: ["RETAILER", "VISITOR_WEB"],
  productArea: "HOME_FEED",
  notifyAfter: "2025-10-01",
});
